// Yorùbá royal regalia imagery (AI-generated, earthy-gold theme) used across
// the Royal Titles page and the homepage reel. Mapped per region so each
// kingdom keeps a consistent visual identity.
export const THRONE_IMAGES = [
  "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/0c29da4c6391d87d1054f9a885a16bb0625b49b0fda2e823c949b7dbf78515ab.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/82421e8955d9605b87150697b6cf32ac44e96b55acedcdd5965577c5ccb1b6f8.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/552fa2b3c4ebdabbeca151bc9b64679d76675fc040dacd43380da519c1c012f5.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/623f77f937c2bc6eb0e666fced6abaf2ef42415dc1319d1e259b9ce10ed59c6a.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/d6ebb4bea6fca309c29953ead4fd29e2b64015bed09b952a74c6a9a450e53f68.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/b43b550a1d331f8976194b15ffb17ffb12e7bb31fb1962a09b02227aa59854d3.jpeg",
];

export const imageFor = (region) => {
  const s = region || "";
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return THRONE_IMAGES[h % THRONE_IMAGES.length];
};
